import{gql as r}from"@apollo/client";const e=r`
  mutation startUserFlowStepUsingUrls($userFlowStepUrl: String!, $userFlowUrl: String!, $forceNewTracking: Boolean) {
    userFlowStepTrack {
      startUserFlowStepUsingUrls(userFlowStepUrl: $userFlowStepUrl, userFlowUrl: $userFlowUrl, forceNewTracking: $forceNewTracking) {
        id
      }
    }
  }
`;export{e as START_USER_FLOW_STEP_USING_URLS_MUTATION};
//# sourceMappingURL=useStartUserFlowStepUsingUrls.graphql.js.map
